<template>
	<div class="MainBox">

    <div class="TableHead">
      <ul class="TableHeadRight" style="display: flex">
        <div class="SearchBox" style="flex: 1">
          <input placeholder="输入企业员查询" v-model="searchText" v-on:keyup.13="GetList"/>
          <a class="SearchBtn" @click="GetList">搜索</a>
        </div>
      </ul>
      <ul class="clear"></ul>
    </div>

    <div class="TableMain">
      <table class="table StripeTable">
        <thead>
          <tr>
            <th>操作员</th>
            <th>生码数量</th>
            <th>授权截止时间</th>
            <th>编辑企业</th>
            <th>ip</th>
            <th>地址</th>
            <th>操作时间</th>
          </tr>
        </thead>
        <tbody class="TRHoverStyle" v-if="datas">
          <tr v-for="(item,index) in datas" v-bind:key="index">
            <td>
              <a v-if="item.role == 10">管理员</a>
              <a v-else>{{item.name}}</a>
            </td>
            <td>
              <a v-if="item.role == 10">{{item.code_limit}}</a>
              <a v-else>-</a>
            </td>
            <td>
              <a v-if="item.due_date">{{item.due_date}}</a>
              <a v-else>-</a>
            </td>
            <td>{{item.org_name ? '组织（' + item.org_name + ')' : '商户（' + item.business_name + ')'}}</td>
            <td v-text="item.ip"></td>
            <td v-text="item.address"></td>
            <td v-text="item.created_at"></td>
          </tr>
        </tbody>
      </table>
      <K-Transition :isLoding="isLoding" :subHint="subHint" v-if="!datas"></K-Transition>
      <!-- 分页器 -->
      <K-Paging :page="page" :totalPages="totalPages" @ChangePage="ChangePage" @SkipPage="SkipPage"></K-Paging>

    </div>

    <!-- loading -->
    <K-Loading v-if="loading"></K-Loading>

    <!-- toast -->
    <K-Toast :Toast="Toast" @ChangeToast="ChangeToast"></K-Toast>

	</div>
</template>

<script>
var self;
import axios from 'axios'
import Paging from '@/components/common/Paging.vue'
import Transition from '@/components/common/Transition.vue'
import Loading from '@/components/common/Loading.vue'
import Toast from '@/components/common/Toast.vue'
export default {
  name: 'Message',
  components: {
    'K-Paging': Paging,
    'K-Transition': Transition,
    'K-Loading': Loading,
    'K-Toast': Toast
  },
  data () {
    return {
      searchText: '',
      oid:null,
      uid:null,
      page:1,
      msg:null,
      id:null,
      loading:false,
      Toast:{
        state: false,
        type: 0,
        txt: null
      },
      subHint:'数据加载中...',
      isLoding:true,
      totalPages:0,
      datas:null
    }
  },
  created () {
    self = this;
    self.uid = localStorage.getItem("wwmxt_Rootid");
    if(localStorage.getItem("wwmxt_Rootid")){
      self.oid = localStorage.getItem("wwmxt_Rootid").substring(0,4);
    }
    axios.defaults.headers.common['token'] = localStorage.getItem("wwmxt_Token");
  },
  mounted () {
    self.GetList();
  },
  methods: {
    ToastFun (type,txt) {
      self.Toast.state = true;
      self.Toast.type = type;
      self.Toast.txt = txt;
    },
    ChangeToast () {
      self.Toast.state = false;
    },
    ChangePage (data) {  //上下翻页
      if(data.te == 1){
        if(self.page > 1){
          self.page--
        }
      }else{
        if(self.page < self.totalPages){
          self.page++
        }
      }
      self.GetList();
    },
    SkipPage (data) {  //跳转分页
      self.page = data.ix;
      self.GetList();
    },
    HandleModel (status,id) {
      self.id = id;
    },
    GetList () {
      self.datas = null;
      self.isLoding = true;
      axios.post(self.GetServerUrl(1)+"operation", {page: self.page, eType: 'authUserPackage', searchContent: self.searchText})
      .then(function (response){
        const datas = response.data.meta.data;
        datas.forEach(item => {
          const jsonObj = JSON.parse(item.remark);
          item.code_limit = jsonObj.code_limit === -1 ? '无限' : jsonObj.code_limit;
          item.due_date = jsonObj.due_date;
        });

        self.datas = datas;
        self.isLoding = false;
        //总页数
        self.totalPages = response.data.meta.last_page;
      }).catch(function (error){
        self.subHint = self.ErrorHint(error);
        self.isLoding = false;
      })
    }
  }
}
</script>

<style scoped>

</style>
